<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container class="evaluation">
		<v-layout row>
			<v-btn @click="openOfferView" class="no-print">
				Podgląd oferty
			</v-btn>
			<v-menu offset-y open-on-hover v-if="viewData.volunteers.length > 0">
				<template v-slot:activator="{ on }">
					<v-btn class="no-print" v-on="on">
						Wolontariusze
					</v-btn>
				</template>
				<v-list>
					<v-list-tile v-for="(volunteer, index) in viewData.volunteers" v-bind:key="index"
						@click="showVolunteerProfile(volunteer.id)">
						<v-icon class="mr-2">account_circle</v-icon>
						{{volunteer.name}} {{volunteer.surname}}
					</v-list-tile>
				</v-list>
			</v-menu>
			<v-spacer></v-spacer>
			<v-btn @click="print" class="mr-3 no-print">Wydrukuj</v-btn>
		</v-layout>

		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Opinia placówki</h2>
				<div class="evaluation-card evaluation-font-size">
					<div>
						<strong class="mr-3">Nazwa oferenta:</strong> {{viewData.mainBidder}}
					</div>
					<div>
						<strong class="mr-3">Nazwa oferty:</strong> {{viewData.offerTitle}}
					</div>
					<div>
						<strong class="mr-3">Numer oferty:</strong> {{viewData.offerCode}}
					</div>
					<div>
						<strong class="mr-3">Suma kontrolna:</strong> {{viewData.controlSum}}
					</div>
					<div class="mt-3" v-if="viewData.donations.length === 1">
						<strong class="mr-3">Wnioskowana kwota:</strong> {{formatMoney(viewData.donations[0])}} PLN
					</div>
					<div class="mt-3" v-else>
						<strong class="mr-3">Wnioskowane kwoty</strong>
						<div class="ml-2" v-for="(donation, index) in viewData.donations" v-bind:key="index">
							<strong class="mr-3">Moduł {{index + 1}}:</strong> {{formatMoney(donation)}} PLN
						</div>
					</div>
					<div class="mt-3">
						<strong class="mr-3">Kraj:</strong> {{viewData.country}}
					</div>
					<div v-if="viewData.extraCountries.length > 0">
						<strong class="mr-3">Kraje dodatkowe:</strong> {{viewData.extraCountries.join(', ')}}
					</div>
					<div v-if="viewData.author">
						<strong class="mr-3">Autor:</strong> {{viewData.author}}
					</div>
					<div v-if="viewData.firstSendDate">
						<strong class="mr-3">Data pierwszego wysłania:</strong> {{viewData.firstSendDate}}
					</div>
					<div v-if="viewData.latestSendDate">
						<strong class="mr-3">Data ostatniego wysłania:</strong> {{viewData.latestSendDate}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">

		<vue-form-generator
			name="generator"
			ref="vfg"
			:model="evaluationData.model"
			:options="formGenerator.formOptions"
			:schema="formGenerator.currentSchema"
			v-if="viewData.showGenerator">
		</vue-form-generator>

		<hr class="ma-4">

		<div style="page-break-inside: avoid">
			<h3 class="mt-4 mb-4 ml-4">Rekomendacja placówki</h3>
			<v-layout row class="mb-4 evaluation-recommendation-outer no-print">
				<v-flex xs1/>
				<v-flex xs10 :style="recommendationFrameStyle" class="evaluation-recommendation">
					<v-select
						class="ma-3"
						data-vv-name="recommending"
						data-vv-as="Rekomenduję do dofinansowania"
						:error-messages="vErrors.collect('recommending')"
						v-validate="'required'"
						:items="viewData.selectItems"
						:disabled="configuration.disabled"
						item-text="name"
						item-value="value"
						v-model="evaluationData.recommending"
						label="Rekomenduję do dofinansowania *"
						aria-label="recommendation"
						for="expert-evaluation-form-recommending"
						id="expert-evaluation-form-recommending"
					></v-select>
				</v-flex>
			</v-layout>
			<div class="d-none print-only ml-3 header-card-font-size">
				Rekomenduję do dofinansowania: <strong
					class="ml-2 header-card-font-size">{{agencyRecommendation}}</strong>
			</div>
		</div>

		<v-btn v-if="!configuration.disabled" @click="validateAndShowDialog" color="primary"
			class="no-print">
			<v-icon class="mr-2 white--text">send</v-icon>
			Wyślij
		</v-btn>

		<v-btn v-if="!configuration.disabled" @click="saveEvaluation" color="info" class="no-print">
			<v-icon class="mr-2 white--text">save</v-icon>
			Zapisz opinię
		</v-btn>

		<evaluation-confirmation-dialog :action="send" :dialog-model="viewData.sendEvaluationDialog"
			@close-confirmation="viewData.sendEvaluationDialog = false"
			action-label="Wyślij" content="Upewnij się, że wypełniłeś poprawnie formularz zanim zatwierdzisz opinię.
				Po zatwierdzeniu nie będzie możliwości edycji!" header="Wysyłka opinii" icon="send"/>
	</v-container>
</template>

<script>
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Api} from "@/api";
	import {AgencyEvaluation} from "@/api/generated/AgencyEvaluation";
	import EvaluationConfirmationDialog from "../../EvaluationConfirmationDialog";
	import {Numbers} from "@/utils/Numbers";
	import {Files} from "@/utils/Files";

	export default {
		name: "AgencyEvaluationForm",
		components: {EvaluationConfirmationDialog},
		watch: {
			"evaluationData.model": {
				handler () {
					this.applyGenericForm(this.configuration.form);
				},
				deep: true,
			},
		},

		data () {
			return {

				configuration: {
					form: "",
					disabled: false
				},

				evaluationData: {
					model: undefined,
					recommending: undefined
				},

				viewData: {
					showGenerator: false,
					offerId: '',
					offerTitle: '',
					offerCode: '',
					controlSum: '',
					country: '',
					author: '',
          firstSendDate: '',
          latestSendDate: '',
					donations: [],
					extraCountries: [],
					sendEvaluationDialog: false,
					volunteers: [],
					selectItems: [
						{
							name: "TAK", value: true,
						},
						{
							name: "NIE", value: false,
						},
					],
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: []
				},
			};
		},

		created () {
			this.loadData();
		},

		computed: {
			recommendationFrameStyle () {
				let color = this.evaluationData.recommending === true ? 'palegreen' :
					this.evaluationData.recommending === false ? 'palevioletred' : 'lightgray';
				return "border:2px solid " + color + "; border-radius: 25px;";
			},

			agencyRecommendation () {
				let found = this.viewData.selectItems.find(item => item.value === this.evaluationData.recommending);
				if (!found) return "";
				return found.name;
			}
		},

		methods: {
			async loadData () {

				await Api.syncGet(this, "/agency-evaluation/configuration?contestId=".concat(this.$route.params.id), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);
					this.formGenerator.currentSchema = genericFormUtil.getSectionSchemaFromSchema(this.configuration.form, 0, this.configuration.disabled);
				});

				AgencyEvaluation.get(this, this.$route.params.evaluationId, success => {
					this.viewData.offerTitle = success.title;
					this.viewData.offerId = success.offerId;
					this.viewData.offerCode = success.offerCode;
					this.viewData.controlSum = success.controlSum;
					this.viewData.author = success.nameSurname;
					this.viewData.country = success.country;
					this.viewData.volunteers = success.volunteers;
					this.evaluationData.recommending = success.evaluationSet ? success.recommending : undefined;
					this.viewData.extraCountries = [];
          this.viewData.firstSendDate = success.firstSendDate;
          this.viewData.latestSendDate = success.latestSendDate;
		  			this.viewData.mainBidder = success.mainBidder;
					success.extraCountries.forEach(country => {
						this.viewData.extraCountries.push(country);
					});
					this.evaluationData.extraCountries = success;
					while (this.viewData.donations.length) {
						this.viewData.donations.pop();
					}
					success.requestedDonations.forEach(donation => {
						this.viewData.donations.push(donation);
					});

					if (success.evaluationStatus === 'FINISHED') {
						this.configuration.disabled = true;
					}
					if (success.filledForm === null) {
						this.evaluationData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.evaluationData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;
				});
			},

			saveEvaluation () {
				AgencyEvaluation.putData(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano opinię", successResponse);
					this.loadData();
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać opinii", errorResponse);
				});
			},

			async send () {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (result) {
						AgencyEvaluation.putFinish(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
							this.$messagesBus.$emit("success", "Opinia została wysłana!", successResponse);
							this.$router.push("/app/evaluations/agency");
						}, errorResponse => {
							this.viewData.sendEvaluationDialog = false;
							this.$messagesBus.$emit("error", "Nie udało się wysłać opinii", errorResponse);
						});
					} else {
						this.viewData.sendEvaluationDialog = false;
						this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane opinii");
					}
				});
			},

			prepareFormData () {
				return {
					evaluationSet: this.evaluationData.recommending !== undefined,
					recommending: this.evaluationData.recommending === undefined ? false : this.evaluationData.recommending,
					filledForm: genericFormUtil.encodeSchema(this.evaluationData.model)
				};
			},

			applyGenericForm (form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.evaluationData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async validateAndShowDialog () {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane formularza");
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (!result) {
						this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane opinii");
					} else {
						this.viewData.sendEvaluationDialog = true;
					}
				});
			},

			showVolunteerProfile(volunteerId) {
				this.$router.openInNewTab({name: "profileView", params: {userId: volunteerId}});
			},

      openOfferView() {
        this.$router.openInNewTab('/view/contest/' + this.$route.params.id + '/offer/' + this.viewData.offerId);
      },

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getEvaluationPrintUrl(
						this.$route.params.id,
						this.$route.params.evaluationId,
						"agency"
					),
					"opinia_placówki.pdf"
				);
			},
		},

		mixins: [
			Numbers
		]
	};
</script>

<style scoped>
	.header-card-font-size {
		font-size: 14px;
	}

	@media print {
		.header-card-font-size {
			font-size: 13px;
		}

		.evaluation-font-size * {
			font-size: 13px;
		}
	}
</style>
